import { IListStringItem } from '@/utils/types/commonTypes'

export const unsubmittedSerialCodes = (
  apiSerial: IListStringItem[],
  localSerial: IListStringItem[],
  removedSerial: IListStringItem[] = []
): string[] => {
  const apiCodes = new Set(apiSerial.map((item) => item.code))
  const activeCodes = new Set(localSerial.map((item) => item.code))

  const added = localSerial.filter((item) => !apiCodes.has(item.code)).map((item) => item.code)
  const removed = [...new Set(removedSerial.map((item) => item.code))].filter(
    (code) => apiCodes.has(code) && !activeCodes.has(code)
  )

  return [...added, ...removed]
}
